import { getPortalBasename } from './metadata';

/**
 * The "home" destination for the logo and the 404 page. With multiple spaces
 * on the platform there is no single portal root, so this resolves to the
 * current app's own basename.
 */
export const getPortalHomePath = () => {
  var _getPortalBasename;
  return (_getPortalBasename = getPortalBasename()) !== null && _getPortalBasename !== void 0 ? _getPortalBasename : '/';
};